<template>
  <div class="shopAddEdit">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      class="demo-ruleForm"
    >
      <el-form-item label="绑定用户" prop="wlUserId">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.wlUserId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          @change="wlUserIdchange"
          :loading="loading"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.nickname"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input :readonly="isQuery" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input :readonly="isQuery" v-model="ruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="店铺名" prop="storeName">
        <el-input :readonly="isQuery" v-model="ruleForm.storeName"></el-input>
      </el-form-item>
      <el-form-item label="店铺地址" prop="address">
        <el-input :readonly="isQuery" v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="银行户名" prop="bankAccount">
        <el-input :readonly="isQuery" v-model="ruleForm.bankAccount"></el-input>
      </el-form-item>
      <el-form-item label="银行账号" prop="bankCardNo">
        <el-input :readonly="isQuery" v-model="ruleForm.bankCardNo"></el-input>
      </el-form-item>

      <el-form-item label="开户银行名称" prop="bankName">
        <el-input :readonly="isQuery" v-model="ruleForm.bankName"></el-input>
      </el-form-item>
      <el-form-item label="开户支行名称" prop="bankSubName">
        <el-input :readonly="isQuery" v-model="ruleForm.bankSubName"></el-input>
      </el-form-item>
      <el-form-item label="合同起止时间" prop="contractTime">
        <el-date-picker
          unlink-panels
          style="width: 100%"
          value-format="yyyy-MM-dd"
          :readonly="isQuery"
          v-model="ruleForm.contractTime"
          @change="contractTimechange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="经度" prop="longitude">
        <el-input :readonly="isQuery" v-model="ruleForm.longitude"></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude">
        <el-input :readonly="isQuery" v-model="ruleForm.latitude"></el-input>
      </el-form-item>
      <el-form-item label="上传" prop="infoImg" v-if="!isQuery">
        <el-upload
          v-show="!isQuery"
          class="avatar-uploader"
          action="#"
          :before-upload="beforeAvatarUpload"
          accept="image/jpeg, image/gif, image/png, image/bmp"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div class="el-upload__tip" slot="tip">
            请上传（身份证，银行卡，合同，营业执照）图片
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="当前（身份证，银行卡，合同，营业执照）"
        v-if="imgList.length != 0"
      >
        <div class="imgBox">
          <div class="imgBox_item" v-for="(item, key) in imgList" :key="key">
            <!-- <img style="width: 100%; height: 100%" :src="item" @click="goImg(item)" /> -->
            <el-image
              style="width: 100%; height: 100%"
              :src="item"
              :preview-src-list="imgList"
            >
            </el-image>
            <span class="remove" @click="remove(key)" v-if="!isQuery">
              <i class="el-icon-delete"></i>
            </span>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="!isQuery">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { publicMixin } from "@/mixins/publicMixin";
import { frontUserlist, frontUsercheckUserBind } from "@/api/management";
export default {
  name: "shopAddEdit",
  props: ["isWhat", "shopData", "isQuery"],
  mixins: [publicMixin],
  data() {
    return {
      ruleList: [],
      wlStreetId: [],
      name: "",
      options: [],
      value: [],
      loading: false,
      streetList: [],
      communityList: [],
      imgList: [],
      ruleForm: {
        wlUserId: "",
        name: "",
        phone: "",
        address: "",
        bankAccount: "",
        bankCardNo: "",
        bankName: "",
        longitude: "",
        latitude: '',
        bankSubName: "",
        infoImg: "",
        storeName: "",
        id: "",
        contractTime: [],
        contractStart: "",
        contractEnd: "",
      },
      rules: {
        wlUserId: [
          { required: true, message: "请绑定用户", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名名称", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入店铺地址", trigger: "blur" },
        ],
        bankAccount: [
          { required: true, message: "请输入银行户名", trigger: "blur" },
        ],
        bankCardNo: [
          { required: true, message: "请输入开户银行", trigger: "blur" },
        ],
        bankName: [
          { required: true, message: "请输入开户银行名称", trigger: "blur" },
        ],
        bankSubName: [
          { required: true, message: "请输入开户支行名称", trigger: "blur" },
        ],
        storeName: [
          { required: true, message: "请输入店铺名", trigger: "blur" },
        ],
        longitude: [
          { required: false, message: "请输入经纬度", trigger: "blur" },
        ],
        latitude: [
          { required: false, message: "请输入经纬度", trigger: "blur" },
        ],
        contractTime: [
          { required: true, message: "请选择合同起止日期", trigger: "blur" },
        ],
        infoImg: [
          {
            required: true,
            message: "请上传身份证，银行卡，合同，营业执照图片",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    shopData(val) {
      if (val) {
        this.ruleForm.wlUserId = val.wlUserId;
        this.ruleForm.longitude = val.longitude;
        this.ruleForm.latitude = val.latitude;
        this.ruleForm.name = val.name;
        this.ruleForm.phone = val.phone;
        this.ruleForm.address = val.address;
        this.ruleForm.bankAccount = val.bankAccount;
        this.ruleForm.bankCardNo = val.bankCardNo;
        this.ruleForm.bankName = val.bankName;
        this.ruleForm.bankSubName = val.bankSubName;
        this.ruleForm.storeName = val.storeName;
        this.ruleForm.contractStart = val.contractStart;
        this.ruleForm.contractEnd = val.contractEnd;
        this.ruleForm.infoImg = val.infoImg;
        let tmpArr = [];
        tmpArr.push(new Date(val.contractStart));
        tmpArr.push(new Date(val.contractEnd));
        this.ruleForm.contractTime = tmpArr;
        this.imgList = val.infoImg.split(",");
        this.ruleForm.id = val.id;
        let obj = [
          {
            id: val.wlUserId,
            nickname: val.wlUserName,
          },
        ];
        this.options = obj;
      }
    },
  },
  computed: {},
  methods: {
    wlUserIdchange(val) {
      frontUsercheckUserBind({
        busiUserId: this.ruleForm.id || "",
        cate: "2",
        wlUserId: val,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            console.log("验证通过");
          } else {
            console.log("验证未通过");
            this.$message.error("此用户不可被绑定");
            this.ruleForm.wlUserId = "";
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remove(key) {
      this.imgList.splice(key, 1);
      this.ruleForm.infoImg = this.imgList.toString();
      this.$refs.ruleForm.validateField("infoImg");
    },
    goImg(item) {
      window.open(item);
    },
    contractTimechange(val) {
      this.ruleForm.contractStart = val[0];
      this.ruleForm.contractEnd = val[1];
    },
    formatDateswitchDate(standardTime) {
      if (standardTime != "") {
        let a = standardTime;
        var Month = a.getMonth() + 1;
        var MonthDate;
        var DayDate = a.getDate();
        var Day;
        if (Month < 10) {
          MonthDate = "0" + Month;
        } else {
          MonthDate = Month;
        }
        if (DayDate < 10) {
          Day = "0" + DayDate;
        } else {
          Day = DayDate;
        }
        var datetime = a.getFullYear() + "-" + MonthDate + "-" + Day;
        return datetime;
      }
    },
    remoteMethod(query) {
      if (query) {
        this.loading = true;
        frontUserlist({ name: query }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
      }
    },
    // getfrontUserlist() {
    //   frontUserlist({ name: "" }).then((res) => {
    //     if (res.code == 200) {
    //       this.options = res.data;
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    beforeAvatarUpload(file) {
      this.uploadFile(file).then((res) => {
        // this.ruleForm.infoImg.push(res);
        this.imgList.push(res);
        this.ruleForm.infoImg = this.imgList.toString();
        this.$refs.ruleForm.validateField("infoImg");
      });
      return false;
    },
  },
  created() {
    // this.getfrontUserlist();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
.shopAddEdit {
  padding: 0px 24px 24px 24px;
  ::v-deep .el-select {
    width: 100%;
  }
  .imgBox {
    display: flex;
    flex-wrap: wrap;
  }
  .imgBox_item {
    width: 60px;
    height: 60px;
    margin-right: 20px;
    margin-top: 20px;
    position: relative;
    .remove {
      display: none;
    }
  }
  .imgBox_item:hover {
    .remove {
      display: inline-block;
      width: 25px;
      height: 25px;
      color: red;
      position: absolute;
      top: -15px;
      right: -15px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
